import { render, staticRenderFns } from "./AdminInfo.vue?vue&type=template&id=caec11e6&scoped=true&"
import script from "./AdminInfo.vue?vue&type=script&lang=js&"
export * from "./AdminInfo.vue?vue&type=script&lang=js&"
import style0 from "./AdminInfo.vue?vue&type=style&index=0&id=caec11e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caec11e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/yx-web-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('caec11e6')) {
      api.createRecord('caec11e6', component.options)
    } else {
      api.reload('caec11e6', component.options)
    }
    module.hot.accept("./AdminInfo.vue?vue&type=template&id=caec11e6&scoped=true&", function () {
      api.rerender('caec11e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Activity/Children/AdminInfo.vue"
export default component.exports